import { isString, toNumber, omit } from 'lodash';
import { conformToMask, createNumberMask } from './inputMasks';
class NumberMask {
    constructor(maskOptions) {
        this._maskOptions = maskOptions;
        this._mask = createNumberMask({
            prefix: '',
            allowDecimal: true,
            decimalLimit: 2,
            integerLimit: 13,
            ...omit(maskOptions, ['roundToNearestFraction']),
        });
    }
    get mask() {
        return this._mask;
    }
    normalize = (s, retroCompatibility = true) => {
        if (this._maskOptions?.roundToNearestFraction) {
            return this.normalizeToFraction(s, retroCompatibility);
        }
        return this.normalizeStandard(s, retroCompatibility);
    };
    normalizeStandard = (s, retroCompatibility = true) => {
        if (!s) {
            return s;
        }
        if (s.startsWith('.')) {
            s = `0${s}`;
        }
        if (retroCompatibility) {
            if (/.*\.0*$/.test(s)) {
                s = s.substring(0, s.indexOf('.'));
            }
        }
        return conformToMask(s, this._mask, { guide: false }).conformedValue;
    };
    roundToNearestFraction = value => {
        const factor = 1 / this._maskOptions.roundToNearestFraction;
        return Math.round(value * factor) / factor;
    };
    normalizeToFraction = (s, retroCompatibility = true) => {
        if (!s) {
            return s;
        }
        if (s.startsWith('.')) {
            s = `0${s}`;
        }
        if (!retroCompatibility) {
            const value = conformToMask(s, this._mask, {
                guide: false,
            }).conformedValue;
            return value;
        }
        if (/.*\.0*$/.test(s)) {
            s = s.substring(0, s.indexOf('.'));
        }
        let conformedValue = conformToMask(s, this._mask, {
            guide: false,
        }).conformedValue;
        const numericCharacters = conformedValue.match(/[\d.]/g) || [];
        const rawNumberValue = parseFloat(numericCharacters.join(''));
        const roundedValue = this.roundToNearestFraction(rawNumberValue);
        conformedValue = conformToMask(roundedValue.toString(), this._mask, {
            guide: false,
        }).conformedValue;
        return conformedValue;
    };
    stringify = apiValue => {
        if (Number.isFinite(apiValue)) {
            return this.normalize(apiValue.toString());
        }
        else {
            return '';
        }
    };
    parse = uiValue => {
        if (isString(uiValue) && uiValue.length) {
            const numberCharacters = uiValue.match(/[\d.]/g) || [];
            return toNumber(numberCharacters.join(''));
        }
    };
}
export default NumberMask;
//# sourceMappingURL=numberMask.js.map